require('./index.less');

var locale = require('./i18n');
var tpl = require('./index.html');
var hash = require('./hash');

var loginPage = {
    init: function() {
        var that = this;
        var settings = window.loginPageSettings;

        // Set mode
        $('body').addClass((settings.style || 'right') + '-mode')
            .html(tpl({
                projectTitle: window.projectTitle,
                locale: locale(),
                logoUrl: window.logoUrl
            }));

        if (window.logoUrl) {
            $('img.logo').css({
                height: (settings.logoHeight || 72) + 'px',
                marginTop: -(settings.logoHeight || 72) + 'px'
            });
        } else {
            $('img.logo').hide();
        }

        // Set background
        if (settings.backgroundImgUrl) {
            $('body').css({
                backgroundImage: 'url("' + settings.backgroundImgUrl + '")',
            });

            var transparency = (settings.transparency === 0 
                || settings.transparency  === '' 
                || typeof settings.transparency === 'undefined')
                ? 0.9 : settings.transparency;
            var opacity = 1 - settings.transparency;
            $('.bg-mask').css('opacity', opacity);
        }

        $('.project-title').css({
            fontSize: (settings.titleFontSize || 28) + 'px',
            fontWeight: settings.titleFontWeight || 'normal'
        });

        if (enableVeriCode === false) {
            $('.login').addClass('no-veri-code')
                .find('.veri-code-line').remove();
        } else {
            $('.refresh-code').on('click', function() {
                that.refreshCode();
            });
            $('.captcha').on('click', function() {
                that.refreshCode();
            });
            that.refreshCode();
        }

        // Set login
        $('.login-btn').button()
            .click(function() {
                $('.tips').html('').removeClass('ui-state-error');
                var uid = $('.uid').val();
                var pwd = $('.pwd').val();
                var vcode = $('.code').val();
                if (!uid || !pwd) {
                    $('.tips').addClass('ui-state-error')
                        .html(locale('nullTips'));
                    return;
                }
                if (enableVeriCode !== false && !vcode) {
                    $('.tips').addClass('ui-state-error')
                        .html(locale('inputCodeTips'));
                        return;
                }
                pwd = hash.digest(window.hashType, pwd);
                var loginURL = window.location.pathname.replace(/\/$/, '');
                $.ajax({
                    url:  loginURL + '/' + uid + '/' + pwd + '?code=' + (vcode || ''),
                    dataType: 'json',
                    type: 'post',
                    success: function(result) {
                        if (!result.success) {
                           $('.tips').addClass('ui-state-error').html(locale(result.code));
                            that.refreshCode();
                        } else {
                            var rd = location.search.match(/redirect=([^&]+)/);
                            if (rd) {
                                return location.href = decodeURIComponent(rd[1]);
                            }
                            location.href = homePageURL + location.hash
                        }
                    },
                    error: function(e) {
                        alert(e.responseText);
                        that.refreshCode();
                    }
                });
        });


        $(window).keyup(function(e) {
            if (e.keyCode === 13) {
                $('.login-btn').focus().click();
            }
        });

        if (settings.noAnimation) {
            if (settings.style !== 'center') {
                $('.login-bg').css({
                    width: '38.2%',
                    minWidth: '388px'
                });
                $('.login').css('top','50%');
                
            } else {
                $('.login-bg').css({
                    height: '61.8%',
                    minHeight: '370px'
                });
                $('.login').show();
            }
            return
        }

        // Run animation
        if (settings.style !== 'center') {
            $('.login-bg').animate({
                width: '38.2%'
            }, 300, 'easeOutQuad', function() {
                $('.login-bg').css('min-width', '388px');
                $('.login').animate({top: '50%'}, 500, 'easeOutBounce');
            });
        } else {
            $('.login-bg').animate({
                height: '61.8%'
            }, 500, 'easeOutQuad', function() {
                $('.login-bg').css('min-height', '370px');
                $('.login').show('drop', 300);
            });
        }
    },
    refreshCode: function() {
        if (window.captchaUrl) {
            $('.captcha').attr('src', window.captchaUrl + '?t=' + new Date().getTime());
        }
    }
};

$(function() {
    loginPage.init();
});


//////////////////
// WEBPACK FOOTER
// ./src/pages/login/index.js
// module id = 0
// module chunks = 0